import * as React from "react";
import { Props } from "../components/ModalComponent";
import { RequiredLiteralKeys } from "../../../interfaces/api";
import { addModal } from "./addModal";
import { ModalStackItemProps } from "../interfaces/modals";

const ModalComponent = React.lazy(() => import('../components/ModalComponent'));
type ComponentProps<P> = (undefined extends RequiredLiteralKeys<P>
  ? { componentProps: Omit<P, keyof ModalStackItemProps<any>> }
  : { componentProps?: Omit<P, keyof ModalStackItemProps<any>> }
  )

export type ComponentModalContext<C extends React.ComponentType> = ComponentProps<React.ComponentProps<C>>;

type ModalOptions = Parameters<typeof addModal>[2];

const mergeOptions = (options1: ModalOptions, options2: ModalOptions): ModalOptions => {
  return options1 && options2
    ? { ...options1, ...options2 }
    : options1 || options2;
}

export function createComponentModalOpener<P>(
  component: React.ComponentType<P>,
  selfOptions?: ModalOptions
) {
  return (
    props: Omit<Props & ComponentProps<P>, 'component'>,
    options?: ModalOptions
  ) => addModal(
    ModalComponent,
    { ...props, component },
    mergeOptions(selfOptions, options),
  );
}

export const createModalOpener = <Props extends {}>(
  component: React.LazyExoticComponent<React.ComponentType<ModalStackItemProps<Props>>>,
  selfOptions?: ModalOptions
) => {
  return (props: Props, options?: ModalOptions) => addModal(component, props, mergeOptions(selfOptions, options));
}

export const openConfirm = createModalOpener(React.lazy(() => import('../components/ModalConfirm')), { name: 'confirm' });
export const openModal = createModalOpener(React.lazy(() => import('../components/ModalModal')), { name: 'modal' });
